/**
 * Determines if an email address belongs to an internal Siemens domain.
 * @param email The email address to check.
 * @returns True if the email is internal, false otherwise.
 */
export function isInternalUserEmail(email: string): boolean {
    const domain = (email ?? '').trim().toLowerCase().split('@')[1] ?? '';
    return domain === 'siemens.com' || domain === 'siemens-healthineers.com';
}
